import { useEffect, useState } from 'react';
import { DATA_CHANGED_EVENT } from '../api/client';

// A counter that ticks every time a write succeeds anywhere in the app (the
// API client announces it). Put it in an effect's dependency list and that
// fetch re-runs the moment any button has changed what it shows — the floor
// totals after an order is accepted from the header, the tab lines after a
// unit is removed, the "Owes" badge after a payment — rather than on the
// next poll, which could be several seconds of a wrong number.
export function useDataVersion(): number {
  const [version, setVersion] = useState(0);
  useEffect(() => {
    const bump = () => setVersion((current) => current + 1);
    window.addEventListener(DATA_CHANGED_EVENT, bump);
    return () => window.removeEventListener(DATA_CHANGED_EVENT, bump);
  }, []);
  return version;
}
